import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "preview"]

  connect () {
    console.log("dynform/photo_controller connected")
  }

  reset () {
    this.inputTarget.value = null;
    this.previewTarget.innerHTML = "";
  }

  photoViaBrowse() {
    this.inputTarget.removeAttribute("capture");
  }

  photoViaCamera() {
    this.inputTarget.setAttribute("capture", "camera");
  }

  handleImageSelect(event) {
    const files = event.target.files;

    if (files.length < 1) { return; }

    const file = files[0];

    if (!file.type.startsWith("image/")) {
      return;
    }

    this.previewTarget.innerHTML = '';

    // Create a container for each image and its remove button
    const imageContainer = document.createElement("div");
    imageContainer.classList.add(
      "image-preview-container",
      "flex",
      "flex-col",
      "items-center",
      "mr-2",
      "mb-2",
    );

    const img = document.createElement("img");
    img.classList.add("w-24", "h-24", "object-cover", "mt-2"); // Tailwind classes
    img.file = file;
    imageContainer.appendChild(img);

    const reader = new FileReader();
    reader.onload = ((aImg) => (e) => {
      aImg.src = e.target.result;
    })(img);
    reader.readAsDataURL(file);

    // Add a remove button
    const removeButton = document.createElement("button");
    removeButton.innerText = "Remove";
    removeButton.classList.add(
      "bg-pink",
      "text-white",
      "p-1",
      "rounded",
      "text-xs",
      "mt-2",
    );
    if ((new URLSearchParams(document.location.search)).get("view")){
      removeButton.classList.add("hidden")
    }
    removeButton.addEventListener("click", () => {
      this.reset()
    });
    imageContainer.appendChild(removeButton);

    this.previewTarget.appendChild(imageContainer);
  }
}
